import { Content, Row, Col, TextInput, Label, Div, Spacer, Button, Divider, Code, Chip, Autocomplete } from '@gower/react-ui/components';
import { useBoolean } from '@gower/react-ui/hooks';
import { User } from '@gower/shared-sdk/core/users';
import React from 'react';
import { provider, useStore } from './store';
import { UsersEditPassword } from './forms/edit-password';
import { UsersEditForm } from './forms/edit-form';
import { Loader } from '@gower/react-ui/template/loader';


export const UsersEditView = provider( () => {

    const store = useStore();

    return <>
        <Content columns scroll>
            <Col>
                <Row padding={15}>
                    <Col gutter center>
                        <Div padding={10} >
                            {store.Item && <Label xxsemi p bold marginBottom={5}>{store.Item.CompleteName}</Label>}
                            {!store.Item && <Label xxsemi p bold marginBottom={5}>Editar usuario</Label>}
                            <Label xsmall p textGrey>Configurá y editá los datos del usuario.</Label>
                        </Div>
                    </Col>
                    <Spacer />
                </Row>
            </Col>
            <Spacer vertical>
                <Loader status={store.Status}>
                    {store.Item && <>
                        <Content start padding={20} justifyCenter>
                            <Col start maxWidth={800} paddingX={20} paddingBottom={100}>
                                <UsersEditForm store={store} />
                            </Col>
                            <Col start maxWidth={800} paddingX={20} paddingBottom={100}>
                                <UsersEditPassword store={store} />
                            </Col>
                        </Content>
                    </>}
                </Loader>
            </Spacer>
        </Content>
    </>;
} );
